import { useCallback, useEffect, useRef } from 'react'
import { useState } from 'react'
import SwiperCore, { Pagination, EffectCoverflow } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { ILot } from '../types/lot'
import { CardFile } from './UI/Card/File'
import { img } from '../assets/assets'
import { UserMini } from './Users'
import { Price } from './UI/Price'
import { Margin } from '../hoc/Margin'
import { Button, IconButton, IconButtons } from './UI/Buttons'
import { Link } from 'react-router-dom'
import { Share } from './UI/Share'
import { dataFromLotToCard } from './Lots'

SwiperCore.use([Pagination, EffectCoverflow])

export interface TopLotsCarouselProps {
    Lots: ILot[]
}
export const TopLotsCarousel = ({ Lots }: TopLotsCarouselProps) => {
    const [lot, setLot] = useState<ILot>()
    const [showShare, setShowShare] = useState(false)
    const paginationElement = useRef<HTMLDivElement>(null)
    const setId = useCallback(
        (index: number) => {
            const currentIndex = index < 0 ? Lots.length + index : index
            const l = Lots[currentIndex]
            setLot(l)
        },
        [Lots]
    )
    // console.log(paginationElement)

    useEffect(() => {
        setId(-1)
    }, [Lots, setId])

    return (
        <div className="carousel">
            {lot && (
                <div className="carousel__left">
                    <div className="carousel__image">
                        <CardFile card={dataFromLotToCard(lot)}></CardFile>
                    </div>
                    <div className="carousel__info">
                        {lot.User ? (
                            <UserMini
                                user={lot.User}
                                className="carousel__user"
                            ></UserMini>
                        ) : null}
                        <div className="carousel__title">
                            {lot.TokenOriginal?.name || ''}
                        </div>
                        <div className="carousel__text">
                            <span>Description:</span>{' '}
                            {lot.TokenOriginal?.description || ''}
                        </div>
                        <Margin margin={{ top: 20, bottom: 20 }}>
                            <div className="carousel__text carousel__text-mini">
                                <span>Selling for</span>
                            </div>
                            <Price
                                wei={lot.currentCost}
                                className="carousel__price"
                            ></Price>
                        </Margin>
                        <IconButtons>
                            <Link to={`/lot/${lot.id}`}>
                                <Button className="carousel__action">
                                    View
                                </Button>
                            </Link>
                            <IconButton handler={() => setShowShare(true)}>
                                <img src={img.shareIcon} alt="" />
                            </IconButton>
                        </IconButtons>
                    </div>
                </div>
            )}
            <div className="carousel__swiper">
                <Swiper
                    effect="coverflow"
                    initialSlide={0}
                    centeredSlides={true}
                    coverflowEffect={{
                        rotate: 0,
                        stretch: 100,
                        depth: 100,
                        modifier: 2,
                        slideShadows: false,
                    }}
                    breakpoints={{
                        600: {
                            coverflowEffect: {
                                rotate: 0,
                                stretch: 200,
                                depth: 200,
                                modifier: 2,
                                slideShadows: false,
                            },
                        },
                    }}
                    pagination={{
                        clickable: true,
                        el: paginationElement.current,
                    }}
                    onSlideChange={(e) => setId(e.realIndex - 1)}
                >
                    {Lots.map((l, i) => (
                        <SwiperSlide key={l.id} virtualIndex={i}>
                            <div className="carousel-content">
                                <CardFile
                                    card={dataFromLotToCard(l)}
                                ></CardFile>
                                {l.User && (
                                    <UserMini
                                        user={l.User}
                                        className="carousel-content__user"
                                        size="small"
                                    ></UserMini>
                                )}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {lot && (
                <Share
                    show={[showShare, setShowShare]}
                    link={`/lot/${lot.id}`}
                ></Share>
            )}
            <div className="carousel-pagination">
                <div ref={paginationElement}></div>
            </div>
        </div>
    )
}
